import gql from 'graphql-tag';

export const GQL_LIST_PRODUCTS = gql`
    query listProducts($catalog: String, $search: String, $page: Int, $pageSize: Int){
        listProducts(
            catalog: $catalog,
            search: $search,
            page: $page,
            pageSize: $pageSize,
        ){
            search
            items {
                brand
                code
                vendor
                category
                description
                title
                image
                moq
                _id
            }
        }
    }
`;

export const GQL_UPDATE_PRODUCT_VARIANTS = gql`
    mutation updateVariants($_id: String!, $data: [ProductVariantsInput]!) {
    updateVariants(_id: $_id, data: $data) {
        _id
            color {
            _id
            name
        }
            size {
            _id
            name
            description
        }
            priceBreaks {
            _id
            quantity
            price
        }
    }
}
`;

export const GQL_CREATE_PRODUCT_VARIANT = gql`
    mutation addProductVariant($productId: String!, $createVariantData: CreateVariationInput!) {
    createVariant(productId: $productId, data: $createVariantData) {
        _id
            color {
            _id
            name
        }
            size {
            _id
            name
            description
        }
        sku
            priceBreaks {
            _id
            quantity
            price
        }
    }
}
`;
